<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__header">
        <p>{{ ModelProcedure.UnitFullName }}</p>
      </div>
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p>DATOS – REFERENCIAS</p>
            </div>
            <p class="empadronamiento__form_header_info_text" style="text-align:justify;">
              Por favor, te solicitamos incluir datos de personas que puedan dar referencias tuyas, en lo posible vecinos
              de Nordelta o de otros barrios, empresarios, profesionales, entre otros.
            </p>

            <fieldset v-for="(reference, i) in ModelProcedure.References" :key="i">
              <div class="empadronamiento__intro__main__form__container-tittle">
                <p style="text-transform:uppercase;">Referencia {{ i + 1 }} :</p>
                <small style="color:red; padding-left: 0px;">Recordar que no pueden ser familiares directos ni
                  inmobiliaria.</small>
                <p class="delete" v-if="i > 1" @click="deleteReference(i)">Eliminar</p>
              </div>

              <base-input placeholder="Nombre *" v-model="reference.Name"
                :invalid="$v.ModelProcedure.References.$each[i].Name.$invalid && submitted" />

              <base-input placeholder="Apellido *" v-model="reference.LastName"
                :invalid="$v.ModelProcedure.References.$each[i].LastName.$invalid && submitted" />

              <base-input type="tel" placeholder="Teléfono de contacto *" v-model="reference.PhoneNumber"
                :invalid="$v.ModelProcedure.References.$each[i].PhoneNumber.$invalid && submitted" />

              <base-input placeholder="Calle *" v-model="reference.StreetName"
                :invalid="$v.ModelProcedure.References.$each[i].StreetName.$invalid && submitted" />

              <base-input type="number" placeholder="Número *" v-model="reference.StreetNumber"
                :invalid="$v.ModelProcedure.References.$each[i].StreetNumber.$invalid && submitted" />

              <base-input placeholder="Código Postal *" v-model="reference.PostCode"
                :invalid="$v.ModelProcedure.References.$each[i].PostCode.$invalid && submitted" />

              <base-input placeholder="Piso - Opcional" v-model="reference.Floor" />

              <base-input placeholder="Departamento - Opcional" v-model="reference.Department" />

              <base-input placeholder="Localidad *" v-model="reference.City"
                :invalid="$v.ModelProcedure.References.$each[i].City.$invalid && submitted" />

              <base-select placeholder="Provincia *" v-model="reference.StateId" :options="ListStates"
                :invalid="$v.ModelProcedure.References.$each[i].StateId.$invalid && submitted" />

              <base-input placeholder="Profesión *" v-model="reference.Profession"
                :invalid="$v.ModelProcedure.References.$each[i].Profession.$invalid && submitted" />

              <base-input placeholder="Actividad laboral *" v-model="reference.WorkActivity"
                :invalid="$v.ModelProcedure.References.$each[i].WorkActivity.$invalid && submitted" />

              <div class="empadronamiento__intro__main__form__container-tittle">
                <p style="text-transform:uppercase">¿Es actualmente propietario/a o inquilino/a de Nordelta?</p>
                <div class="demo">
                  <input type="radio" :value="true" v-model="reference.IsOwner" />
                  <label>SI</label>
                </div>
                <div class="demo">
                  <input type="radio" :value="false" v-model="reference.IsOwner" />
                  <label>NO</label>
                </div>
              </div>

              <template v-if="reference.IsOwner">
                <select v-model="reference.NeighborhoodId" class="empadronamiento__intro__main__form__container-form">
                  <option value="0" disabled>Barrio</option>
                  <option v-for="(neighborhood, idx) in AllNeighborhoods" :value="neighborhood.NeighborhoodId" :key="idx">
                    {{ neighborhood.Name }}</option>
                </select>
                <base-input placeholder="Unidad" v-model="reference.Unit" />
              </template>
            </fieldset>
          </fieldset>

          <base-add-section label="Agregar referencia" @click="addReference" />
        </form>
        <div class="empadronamiento__intro__button">
          <button-link back>
            <p>Volver</p>
          </button-link>
          <button v-if="!loadingForm" class="active" @click="saveReference()">
            <p>Guardar</p>
          </button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, not } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      loading: true,
      submitted: false,
      loadingForm: false
    };
  },
  computed: {
    ...mapState({
      AllNeighborhoods: state => state.unit.AllNeighborhoods,
      ListStates: state => state.common.ListStates,
      ModelProcedure: state => state.manageVecino.ModelProcedure
    })
  },
  mounted() {
    const self = this
    if (!this.ModelProcedure.hasOwnProperty('UCode')) {
      this.$store.dispatch('getProcedure', {
        ucode: this.$route.query.ucode
      }).then(() => {
        if (self.ModelProcedure.References.length === 0) self.addReference();
        if (self.ModelProcedure.References.length === 1) self.addReference();
        self.$store.dispatch('getSelectedCountryStates', 1)
        self.$store.dispatch('getAllNeighborhoods')
        self.loading = false
      })
    } else {
      if (self.ModelProcedure.References.length === 0) self.addReference();
      if (self.ModelProcedure.References.length === 1) self.addReference();
      self.$store.dispatch('getSelectedCountryStates', 1)
      self.$store.dispatch('getAllNeighborhoods')
      self.loading = false
    }
  },
  methods: {
    addReference() {
      this.$store.dispatch('addReference')
    },

    deleteReference(index) {
      this.$store.dispatch('removeReference', index)
    },

    saveReference() {
      const self = this;
      self.submitted = true;
      if (!self.$v.ModelProcedure.$invalid) {
          self.loadingForm = true;
          this.$store.dispatch("updateProcedure", {
            model: this.ModelProcedure
          }).then(() => {
            this.$router.push('/vecino/terminos-y-condiciones')
          })
      }
      else {
        var element = document.querySelector(".empadronamiento__intro__main__form__container-item .has-error");
        if (element != null)
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    }
  },
  validations: {
    ModelProcedure: {
      References: {
        $each: {
          Name: {
            required
          },
          LastName: {
            required
          },
          Profession: {
            required
          },
          WorkActivity: {
            required
          },
          PhoneNumber: {
            required
          },
          StreetName: {
            required
          },
          StreetNumber: {
            required
          },
          PostCode: {
            required
          },
          City: {
            required
          },
          StateId: {
            required,
            not: not(model => model === 0)
          }
        }
      }
    }
  }
};
</script>
